import apiClient from './client';

/* Psychedelic Journey V2 — Psilocybin "Neural Rewire" gauntlet (batch engine).
   The gauntlet is fought on BatchBossSession; these endpoints orchestrate the
   multi-stage trial. See backend/api/journey_v2.py +
   wiki/reference/psychedelic-journey-v1-remnant-audit.md */

// Start a new journey (or resume the active one). Returns { status, combat }
// where `combat` is a BatchBossSession init payload for the current stage.
export const startPsychedelicJourney = async () => {
  const response = await apiClient.post('/api/journey/v2/start', null, { timeout: 60000 });
  return response.data;
};

// Called on a stage WIN. Returns { status: 'in_progress', combat } for the next
// stage, or { status: 'completed' | 'failed' }.
export const advancePsychedelicJourney = async (trialId) => {
  const response = await apiClient.post(`/api/journey/v2/${trialId}/advance`, null, { timeout: 60000 });
  return response.data;
};

// Called on a stage LOSS — marks the trial failed ("dose wasted").
export const failPsychedelicJourney = async (trialId) => {
  const response = await apiClient.post(`/api/journey/v2/${trialId}/fail`);
  return response.data;
};

// Summary of the active trial (or { active: false }).
export const getActivePsychedelicJourney = async () => {
  const response = await apiClient.get('/api/journey/v2/active');
  return response.data;
};

// Activate Neural Rewire directly from the skill-tree node — no equipment slot.
// Returns { journey_required } (launch gauntlet), { journey_in_progress, trial_id }
// (resume), or { activated, neural_rewire_results } (completed trial paid out).
export const activateNeuralRewire = async () => {
  const response = await apiClient.post('/api/journey/v2/activate');
  return response.data;
};
